.retry {
  margin-left: auto;
}

.close {
  margin-right: auto;
}

.suggestedAction {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 5px;
}

.suggestedActionOptions {
  display: flex;
  flex-direction: column;
  background-color: var(--light-100);
  border-radius: 10px;
}
